import { render, staticRenderFns } from "./Banner-Managment.vue?vue&type=template&id=842c216c&"
import script from "./Banner-Managment.vue?vue&type=script&lang=js&"
export * from "./Banner-Managment.vue?vue&type=script&lang=js&"
import style0 from "./Banner-Managment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports